// extracted by mini-css-extract-plugin
module.exports = {"ImageBG":"ImageBG_ImageBG__2lKCd"};